import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';

import { REMOVE_BOOK_FROM_SHELF } from '@graphql/bookshelf';
import { Context } from '@store/store';
import RemoveBookFromShelfIconOnHover from '@icons/remove-book-from-shelf-icon-on-hover';
import RemoveBookFromShelfIcon from '@icons/remove-book-from-shelf-icon';

import { StyledRemoveBookFromShelfButton } from './remove-book-from-shelf-button.styles';

const RemoveBookToShelfButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);
  const [isHovered, setIsHovered] = useState(null);
  const [removeBookFromShelf, { data }] = useMutation(REMOVE_BOOK_FROM_SHELF);
  return (
    <StyledRemoveBookFromShelfButton
      title="Убрать документ с полки"
      onClick={() => {
        removeBookFromShelf({ variables: { bookId: state.bookId } });
        dispatch({ type: 'SET_IS_ON_SHELF', payload: false });
        dispatch({ type: 'SHOW_SHELF_MODAL', payload: true });
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? (
        <RemoveBookFromShelfIconOnHover
          width={isMobile ? 28 : 32}
          height={isMobile ? 22 : 25}
        />
      ) : (
        <RemoveBookFromShelfIcon
          width={isMobile ? 28 : 32}
          height={isMobile ? 22 : 25}
        />
      )}
    </StyledRemoveBookFromShelfButton>
  );
};

export default RemoveBookToShelfButton;
